<template>
  <LumpSumTradeRowParentItem
    v-if="tradeItem.has_children"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :package-trade-items="$props.packageTradeItems"
    :can-edit-claim="$props.canEditClaim"
    :show-percentages="$props.showPercentages"
    :depth="$props.depth"
  />

  <LumpSumTradeRowLeafItem
    v-else-if="packageTradeItem"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :package-trade-item="packageTradeItem"
    :can-edit-claim="$props.canEditClaim"
    :show-percentages="$props.showPercentages"
    :depth="$props.depth"
  />
</template>

<script setup lang="ts">
import Claim from '@/models/Claim';
import PackageTradeItem from '@/models/PackageTradeItem';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import { computed } from 'vue';
import LumpSumTradeRowLeafItem from './LumpSumTradeRowLeafItem.vue';
import LumpSumTradeRowParentItem from './LumpSumTradeRowParentItem.vue';

const props = withDefaults(
  defineProps<{
    trade?: Trade;
    claim: Claim;
    tradeItem: TradeItem;
    packageTradeItems: PackageTradeItem[];
    canEditClaim: boolean;
    showPercentages?: boolean;
    depth?: number;
  }>(),
  {
    depth: 0,
  },
);

const packageTradeItem = computed(() => {
  return props.packageTradeItems.find((item) => item.trade_item_id === props.tradeItem.id);
});
</script>

<style scoped></style>
